
<template>
    <div>
        <slot></slot>
        <div class="row">
            <div class="col-md-12">
            {{ rangeDescription }}
            </div>
        </div>
        <div class="row sliderarea">
            <div class="col-md-12">
                <vue2-slider
                    ref="slider"
                    :real-time="true"
                    :show="true"
                    :speed="0"
                    :value="currentValue"
                    :min="min"
                    :tooltip="false"
                    :max="max"
                    :height="10"
                    :bgStyle="{'backgroundColor': '#fff', 'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.1)', 'border': '0.1px solid #a6a6a6', 'borderRadius': '20px'}"
                    :sliderStyle="[{'backgroundColor': '#00a3c4', 'borderRadius': '5px'},{'backgroundColor': '#032f5e', 'borderRadius': '5px'}]"
                    :processStyle="{'backgroundImage': '-webkit-linear-gradient(left, #00a3c4, #032f5e)'}"
                    @click="startSlide"
                    @drag-start="startSlide"
                    @callback="changed"
                    @drag-end="endSlide"
                    >
                </vue2-slider>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Slider from 'vue-slider-component';

export default {
    props: ['id', 'title', 'value', 'min', 'max', 'labels'],
    components: {
        vue2Slider
    },
    data: function () {
        return {
            currentValue: [-100, 100],
            dragging: false
        };
    },
    mounted: function () {
        this.currentValue = [this.min, this.max];
    },
    methods: {
        startSlide: function (event) {
            this.dragging = true;
            this.$emit('input', event.value);
        },
        endSlide: function (event) {
            this.dragging = false;
            this.$emit('input', this.currentValue);
        },
        changed: function (val) {
            this.currentValue = val;
            if (!this.dragging) {
                this.$emit('input', val);
            }
        },
        refresh: function () {
            if (this.$refs.slider) {
                this.$refs.slider.refresh();
            }
        }
    },
    computed: {
        rangeDescription: function () {
            var isOnMin = this.currentValue[0] === this.min;
            var isOnMax = this.currentValue[1] === this.max;
            // if (isOnMin && isOnMax) return '';

            if (typeof (this.labels) === 'undefined' || this.labels.length === 0) {
                // if (isOnMax) return ' >' + this.currentValue[0];
                // if (isOnMin) return ' <' + this.currentValue[1];
                return ' ' + this.currentValue[0] + ' to ' + this.currentValue[1];
            }

            if (isOnMax) return ' >' + this.labels[this.currentValue[0] - this.min];
            if (isOnMin) return ' <' + this.labels[this.currentValue[1] - this.min];
            return ' ' + this.labels[this.currentValue[0] - this.min] + ' to ' + this.labels[this.currentValue[1] - this.min];
        }
    },
    watch: {
        'id': function () {
            this.currentValue = [this.min, this.max];
            window.setTimeout(() => {
                this.$refs.slider.refresh();
            }, 10);
        },
        value () {
            if (this.currentValue !== this.value) {
                this.currentValue = this.value;
            }
            window.setTimeout(() => {
                this.$refs.slider.refresh();
            }, 10);
        }
    }
};
</script>




// WEBPACK FOOTER //
// rangeSlider.vue?4bda73ec